module.exports = ".radio-indent {\n    margin-left: 10px\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/create-application/rwi-form/workdetails-rwi/workdetails-rwi.component.css
// module id = ./src/app/create-application/rwi-form/workdetails-rwi/workdetails-rwi.component.css
// module chunks = main